// @flow
import type { AppState } from 'stores'
import { MunicipalityDetail } from 'components/municipalityDetail/component'
import { connect } from 'react-redux'
import { branch, renderNothing } from 'recompose'

export { MunicipalityDetail } from './component'

// eslint-disable-next-line no-unused-vars
const mapStateToProps = ({
  activeMunicipality,
  rentPricesByMunicipality,
  categorySelection
}: AppState) => {
  let currentMunicipality = rentPricesByMunicipality.get(
    activeMunicipality.toString()
  )
  return {
    ...currentMunicipality,
    activeMunicipality,
    selectedBudgetCategory: categorySelection.priceRange,
    selectedFlatSizeCategory: categorySelection.flatSize
  }
}

const hideIfWrongActiveMunicipality = branch(
  props => props.activeMunicipality <= 0,
  renderNothing
)

export default connect(mapStateToProps, undefined)(
  hideIfWrongActiveMunicipality(MunicipalityDetail)
)
